import React, { Component } from 'react';
import { URLImgFront } from '../../../config/URLDB';

const sharedDescription = (
    <p className="text" style={{ textAlign: 'center' }}><br /><br />Cada acción que realices te permitirá acumular puntos que se convertirán en <b>oportunidades de ganar</b>.</p>
);

const slides = [
    {
        background: 'linear-gradient(to right, #5B2482, #852B71)',
        image: (
            <img
                data-aos="zoom-in"
                data-aos-delay="300"
                alt= "Mensual"
                src={`${URLImgFront}/assets/EstrategiasComerciales/mensualV2.svg`}
                className="cooperaGanaMas-image sec02"
            />
        ),
        imageDes: (`${URLImgFront}/assets/EstrategiasComerciales/coin.png`),
        planeLeft: `${URLImgFront}/assets/EstrategiasComerciales/airplaneP.svg`,
        planeRight: `${URLImgFront}/assets/EstrategiasComerciales/airplaneP2.svg`,
        title: (
            <span>
                Así podrás acumular<br></br>puntos de forma<br></br><span className="highlighted">mensual:</span>
            </span>
            
        ),
        /* EN CASO DE QUE SE NECESITE UNA IMAGEN DENTRO DE LA DESCRIPCION, EJEMPLO:
            <img
                src={`${URLImgFront}/assets/Estrategias/ejemplo.png`}
                alt="Descripción visual"
                className="description-image"
            />
        */

        description: sharedDescription
    },
    {
        background: 'linear-gradient(to right, #C83262, #D34044)',
        image: (
            <img
                data-aos="zoom-in"
                data-aos-delay="300"
                alt="Una vez"
                src={`${URLImgFront}/assets/EstrategiasComerciales/unicaVezV2.svg`}
                className="cooperaGanaMas-image sec02 slide2"
            />
        ),
        imageDes: (`${URLImgFront}/assets/EstrategiasComerciales/coin.png`),
        planeLeft: `${URLImgFront}/assets/EstrategiasComerciales/airplanePR.svg`,
        planeRight: `${URLImgFront}/assets/EstrategiasComerciales/airplaneP2R.svg`,
        title: (
            <span>
                Así podrás acumular<br></br>puntos por<br></br><span className="highlighted">única vez:</span>
            </span>
        ),
        description: sharedDescription
    }
];

class Seccion02CooperaGanaMas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSlide: 0,
            screenSize: this.getScreenSize(),
        };
    }

    handleNext = () => {
        this.setState((prevState) => ({
            currentSlide: (prevState.currentSlide + 1) % slides.length
        }));
    };

    handlePrev = () => {
        this.setState((prevState) => ({
            currentSlide: (prevState.currentSlide - 1 + slides.length) % slides.length
        }));
    };


    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    getScreenSize = () => {
        const width = window.innerWidth;

        if (width <= 480) return 'xs';
        if (width > 481 && width < 552) return 'xxs';
        if (width <= 768) return 'sm';
        if (width <= 1025) return 'md';
        if (width > 1025 && width <= 1200) return 'xmd';
        if (width <= 1440) return 'lg';
        if (width <= 1600) return 'xl';
        console.log("ScreenSize:",)
        return 'xxl';
    };

    handleResize = () => {
        const screenSize = this.getScreenSize();
        if (screenSize !== this.state.screenSize) {
            console.log(`Screen size changed to: ${screenSize}`);
            this.setState({ screenSize });
        }
    };

    render() {
        const { currentSlide } = this.state;
        const slide = slides[currentSlide];

        return (
            <React.Fragment>
                <section
                    className="cooperaGanaMas-container context02"
                    style={{ background: slide.background }}
                    data-aos="zoom-in-down"
                >
                    <img
                        key={`planeRight-${currentSlide}`}
                        src={slide.planeLeft}
                        alt="DecorationLeft"
                        className="bg-icon bg-icon-left"
                        data-aos="zoom-out-right"
                        data-aos-delay="300"
                    />
                    <img
                        key={`planeLeft-${currentSlide}`}
                        src={slide.planeRight}
                        alt="DecorationRight"
                        className="bg-icon bg-icon-right"
                        data-aos="zoom-out-left"
                        data-aos-delay="300"
                        data-aos-anchor-placement="bottom-center"
                    />

                    <div className="cooperaGanaMas-content" data-aos="zoom-in" key={currentSlide}>
                        
                        <div className="cooperaGanaMas-text">
                            <h2 className="title" data-aos="flip-up" data-aos-delay="300">{slide.title}</h2>
                            
                            <p data-aos="flip-down" data-aos-delay="300">{slide.description}</p>
                            <img
                                data-aos="zoom-in-left"
                                data-aos-delay="300"
                                className="coin"
                                alt="Moneda"
                                src={slide.imageDes}
                            />
                        </div>

                        {['xs', 'xxs'].includes(this.state.screenSize) ? (
                            <>
                                <div className="cooperaGanaMas-image-wrapper">
                                    {slide.image}
                                </div>
                                <div className="cooperaGanaMas-image-arrows">
                                    <button
                                        data-aos="fade-left"
                                        data-aos-delay="300"
                                        style={{ outline: 'none' }}
                                        className="arrow left" onClick={this.handlePrev}>
                                        <img
                                            src={`${URLImgFront}/assets/EstrategiasComerciales/Boton_slider_izq.svg`}
                                            alt="Anterior"
                                            style={{ width: '100%', height: 'auto' }}
                                        />
                                    </button>
                                    <button
                                        data-aos="fade-right"
                                        data-aos-delay="300"
                                        style={{ outline: 'none' }}
                                        className="arrow right" onClick={this.handleNext}>
                                        <img
                                            src={`${URLImgFront}/assets/EstrategiasComerciales/Boton-slider_der.svg`}
                                            alt="Siguiente"
                                            style={{ width: '100%', height: 'auto' }}
                                        />
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="cooperaGanaMas-image-wrapper">
                                        <button
                                            data-aos="fade-left"
                                            data-aos-delay="300"
                                            style={{ outline: 'none' }}
                                            className="arrow left" onClick={this.handlePrev}>
                                            <img
                                                src={`${URLImgFront}/assets/EstrategiasComerciales/Boton_slider_izq.svg`}
                                                alt="Anterior"
                                                style={{ width: '100%', height: 'auto' }}
                                            />
                                        </button>
                                        {slide.image}
                                        <button
                                            data-aos="fade-right"
                                            data-aos-delay="300"
                                            style={{ outline: 'none' }}
                                            className="arrow right" onClick={this.handleNext}>
                                            <img
                                                src={`${URLImgFront}/assets/EstrategiasComerciales/Boton-slider_der.svg`}
                                                alt="Siguiente"
                                                style={{ width: '100%', height: 'auto' }}
                                            />
                                        </button>
                                    </div>
                           </>
                        )}
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default Seccion02CooperaGanaMas;